import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { useHistory } from 'react-router';

// Styles
import styles from '@/components/ClientHeaders/ClientHeaders.module.css';
// Components
import { Icon } from '@/components/Icon';
import { IconRotate } from '@/components/Icon/types';

// Utilities
import { mergeClassNames } from '@/utils/mergeClassNames';

interface ClientHeaderProps {
  title: string;
  backButton?: boolean;
  children?: React.ReactNode;
  backTarget?: string;
}

export const ClientOverviewHeader = ({ title, backButton = false, children, backTarget }: ClientHeaderProps) => {
  const history = useHistory();
  const goBack = (backTarget: string) => {
    history.push(backTarget);
  };

  return (
    <IonGrid className={styles.header} fixed>
      <IonRow className={mergeClassNames('ion-align-items-center', styles.wrapper)}>
        {backButton && backTarget && (
          <IonCol
            className='ion-justify-content-center ion-align-content-center'
            onClick={() => goBack(backTarget)}
            size='auto'>
            <Icon direction={IconRotate.West} name='chevron' />
          </IonCol>
        )}
        <IonCol size={!children && !backButton ? '12' : backButton && !children ? '11' : '7'}>
          <h1 className={styles.title}>{title}</h1>
        </IonCol>
        {children && (
          <IonCol size='auto' style={{ marginLeft: 'auto' }}>
            {children}
          </IonCol>
        )}
      </IonRow>
    </IonGrid>
  );
};
